<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uP4MXA/tc-custom/9780062859440.jpg?1731794286648" alt="This image is the cover for the book American Princess"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Princess
      </h1>
      <p class="bookDescription body article font2">
        <p>A behind-the-scenes look into the life of Meghan Markle and her romance with Prince Harry—a dishy, delightful must-read filled with exclusive insights for anyone obsessed with the Royal Family.</p><p><b>Leslie Carroll’s books on royalty are “an irresistible combination of <i>People</i> Magazine and the History Channel.”—<i>Chicago Tribune</i></b></p><p>When Prince Harry of Wales took his American girlfriend, Meghan Markle, to have tea with his grandmother the queen, avid royal watchers had a hunch that a royal wedding was not far off. That prediction came true on November 27, 2017, when the gorgeous, glamorous twosome announced their engagement to the world. As they prepare to tie the knot in a stunning ceremony on May 19, 2018, that will be unprecedented in royal history, people are clamoring to know more about the beautiful American who captured Prince Harry’s heart. </p><p>Born and raised in Los Angeles to a white father of German, English, and Irish descent and an African American mother whose ancestors had been enslaved on a Georgia plantation, Meghan has proudly embraced her biracial heritage. In addition to being a star of the popular television series <i>Suits</i>, she is devoted to her humanitarian work—a passion she shares with Harry. Though Meghan was married once before, Prince Harry is a modern royal, and the Windsors have welcomed her into the tight-knit clan they call “The Firm.” Even a generation ago, it would have been unthinkable, as well as impermissible, for any member of Great Britain’s royal family to consider marrying someone like Meghan. Professional actresses were considered scandalous and barely respectable. And the last time an American divorcee married into the Royal Family, it provoked a constitutional crisis!</p><p>In <i>American Princess</i>, Leslie Carroll provides context to Harry and Meghan’s romance by leading readers through centuries of Britain’s rule-breaking royal marriages, as well as the love matches that were never permitted to make it to the altar; followed by a never-before-seen glimpse into the little-known life of the woman bringing the Royal Family into the 21st century; and her dazzling, thoroughly modern romance with Prince Harry. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leslie Carroll
      </h2>
      
      <p class="authorDescription body article"><P>Leslie Carroll is the author of twenty books in three genres, including a series of five nonfiction titles on the loves and lives of European royalty: <I>Royal Affairs, Notorious Royal Marriages, Royal Pains, Royal Romances,</I> and <I>Inglorious Royal Marriages</I>. She also wrote an illustrated hardcover &#8220;coffee table&#8221; book on a thousand years of British royalty commissioned by Sterling, the publishing arm of Barnes &#38; Noble. She and her husband divide their time between the high-rises of Manhattan and the high elevation of Denver. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?076aa3bd